import GeneralStatusBar from './GeneralStatusBar';
import OfflineModeBannerSlot from './OfflineModeBannerSlot';
import OptInBanner from './OptInBanner';
import BEM from 'common/bem';

const classes = BEM.with('BannerStack');

export default function BannerStack() {
  return (
    <div className={classes()} data-test-id="banner-stack">
      <OfflineModeBannerSlot />
      <OptInBanner />
      <GeneralStatusBar />
    </div>
  );
}
